import { useEffect, useState } from "react";
import DataTable from "react-data-table-component";

const defaultStyle = {
   table: {
      style: {
         border: "1px solid #007BFF",
         borderRadius: "5px 5px 0 0",
      },
   },
   rows: {
      style: {
         border: "1px solid #007BFF",
      },
   },
   headRow: {
      style: {
         backgroundColor: "#007BFF",
         border: "1px solid #007BFF",
      },
   },
   headCells: {
      style: {
         padding: "0.5rem 1rem ",
         backgroundColor: "#007BFF",
         color: "#fff",
         fontSize: "18px",
         fontWeight: "400",
         marginBottom: "-1px",
      },
   },
   cells: {
      style: {
         padding: "0.2rem 1rem",
         fontSize: "14px",
      },
   },
};

const oilStyle = {
   table: {
      style: {
         border: "none",
         backgroundColor: "transparent",
      },
   },
   rows: {
      style: {
         minHeight: "52px",
         borderBottom: "1px solid #edf1f6",
         "&:not(:last-of-type)": {
            borderBottom: "1px solid #edf1f6",
         },
      },
   },
   headRow: {
      style: {
         minHeight: "42px",
         backgroundColor: "#f3f6fa",
         borderBottom: "none",
         borderRadius: "8px",
      },
   },
   headCells: {
      style: {
         padding: "0.65rem 0.75rem",
         backgroundColor: "#f3f6fa",
         color: "#5f7088",
         fontSize: "0.78rem",
         fontWeight: "600",
         letterSpacing: "0.01em",
         textTransform: "none",
      },
   },
   cells: {
      style: {
         padding: "0.75rem 0.75rem",
         color: "#4b5c72",
         fontSize: "0.84rem",
         fontWeight: "500",
         alignItems: "flex-start",
      },
   },
};

export default function CustomTable({
   columns,
   data,
   keyField,
   columnFontSize = "18px",
   totalCount,
   rowsPerPage,
   pagination = true,
   onChangeRowsPerPage,
   onChangePage,
   paginationServer,
   theme = "default",
}) {
   const [currentPage, setCurrentPage] = useState(
      localStorage.getItem("customTablePage") || 1
   );

   useEffect(() => {
      const savedPage = localStorage.getItem("customTablePage");
      if (savedPage) {
         setCurrentPage(Number(savedPage));
      }
   }, []);

   const handlePageChange = (page) => {
      setCurrentPage(page);
      localStorage.setItem("customTablePage", page);
      if (onChangePage) onChangePage(page);
   };

   const handleRowsPerPageChange = (newPerPage, page) => {
      setCurrentPage(page);
      localStorage.setItem("customTablePage", page);
      if (onChangeRowsPerPage) onChangeRowsPerPage(newPerPage, page);
   };

   const style =
      theme === "oil"
         ? oilStyle
         : {
              ...defaultStyle,
              headCells: {
                 style: {
                    ...defaultStyle.headCells.style,
                    fontSize: columnFontSize,
                 },
              },
           };

   if (!Array.isArray(data)) {
      return <div>No data found</div>;
   }

   return (
      <div style={{ width: "100%" }} className={theme === "oil" ? "oil-table-wrap" : ""}>
         <DataTable
            columns={columns}
            data={data}
            keyField={keyField || "id"}
            customStyles={style}
            sortable
            fixedHeader={theme !== "oil"}
            pagination={pagination}
            responsive
            dense
            borderColor="#000000"
            paginationServer={paginationServer}
            paginationTotalRows={totalCount}
            paginationPerPage={rowsPerPage}
            paginationDefaultPage={currentPage}
            onChangeRowsPerPage={handleRowsPerPageChange}
            onChangePage={handlePageChange}
            noDataComponent={<div className="oil-table-empty">No records found</div>}
         ></DataTable>
      </div>
   );
}
